import { isEmpty } from "lodash"

/**
 * Edit the individual recipients of an already-published notice.
 *
 * PATCH api/portal/v2/notices/{notice}/recipients
 *
 * The contract is a DIFF, not the desired state: the Portal sends only what changed and never the
 * full recipient list. Both arrays are optional and sending neither is a valid no-op, so empty
 * arrays are omitted rather than sent. A person id may not appear in both arrays; the caller builds
 * these from a selection diff, so that cannot arise here.
 *
 * Add and remove are applied together in a single transaction, and the call is idempotent - an add
 * for somebody already targeted, or a remove for somebody who was not an individual recipient, is
 * reported back under `ignored` rather than failing.
 */
class PatchNoticeRecipientsRequest {

    constructor({ noticeId, addedPersonIds, removedPersonIds }) {
        this.noticeId = noticeId
        this.addedPersonIds = [].concat(addedPersonIds ?? [])
        this.removedPersonIds = [].concat(removedPersonIds ?? [])
    }

    getPayload = () => {

        const payload = {}

        if (!isEmpty(this.addedPersonIds)) {
            payload["added_person_ids"] = this.addedPersonIds
        }

        if (!isEmpty(this.removedPersonIds)) {
            payload["removed_person_ids"] = this.removedPersonIds
        }

        return payload
    }
}

export default PatchNoticeRecipientsRequest
